module.exports = __webpack_public_path__ + "img/145ne.9fae4e1c.svg";